export default () => (to, from, next) => {
  const { user } = window.__INITIAL_STATE__;

  if (to.name === 'tutorials' && !user.permissions.conference) {
    // guest or L1 users are not allowed to visit Tutorials page
    next(`/access-denied?returnUrl=${to.href}`);
  }

  next();
};
